import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  TemplateRef,
  Inject,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  faAngleUp,
  faAngleDown,
  faSpinner,
} from "@fortawesome/pro-light-svg-icons";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
  faExclamationCircle as fasExclamationCircle,
  faTable as fasTable,
  faFileExcel as fasFileExcel,
  faChartLine as fasChartLine,
  faArrowToBottom as fasArrowToBottom,
} from "@fortawesome/pro-solid-svg-icons";
import { Store } from "@ngrx/store";
import { forkJoin, Subscription } from "rxjs";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import {
  SetSectorIndustry,
  SetIndustrySubHeader,
  SetIndustryMengMenuVisibility,
} from "src/app/store/actions/sector-industry.actions";
import {
  IndustryMeta,
  SectorIndustry,
  SectorMetaResponse,
} from "src/app/store/models/industry-page.model";
import {
  PeriodState,
  PeriodUserSettingObj,
  convertPeriodMetaToUserSettings,
  isBasisFullYear,
  getSelectedBasisOptionId,
} from "@va/core-library/period-filter";
import { DeleteDpParams } from "src/app/store/actions/global-subheader.actions";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { SectorsAndIndustriesPageDataService } from "../sectors-and-industries-page-data-service";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { Dictionary } from "src/app/store/models/common_types";
import { DOCUMENT } from "@angular/common";
import {
  INDUSTRY_PAGE_INFO,
  ANALYTICS_FEATURE_NAME,
} from "src/app/sectors-and-industries-page/sector-and-industry-page-constants";
import { AppService } from "src/app/app.service";
import {
  getFormattedLineItemForTracking,
  createUserIndustrySettings,
} from "src/app/sectors-and-industries-page/sector-and-industry-page-utils";
import { environment } from "../../../environments/environment";
import * as dayjs from "dayjs";
import {
  computeAverage,
  computeTotal,
  createCompsTable,
  createCompsTableFilter,
  createTimeseriesCompsTableRows,
  roundToTwo,
} from "src/app/comps-page/utils";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { Observable } from "rxjs/internal/Observable";
import {
  CompsTableColumnData,
  CompTypes,
  CompsTableRow,
  CompsTable,
} from "src/app/comps-page/comps-page.model";
import Highcharts from "highcharts";
import {
  getSelectedPeriods,
  getPeriodTypeDataId,
  convertRelativePeriodIdToLabel,
} from "src/app/utils/period-utils";
import {
  getTickerIdUrl,
  getTickersChunksForDataCall,
} from "src/app/utils/common";
import { MegaMenuService } from "../mega-menu.service";
import { PERIOD_DISPLAY_PREFIXES } from "src/app/common-constants";
import {
  VAIconRegistryService,
  chevronDown,
  chevronUp,
} from "@va/core-library/icons";

/**
 * This represent Core KPI's and Financial information of Industry
 */
@Component({
  selector: "app-industry-content",
  templateUrl: "./industry-content.component.html",
  styleUrls: ["./industry-content.component.scss"],
  host: { class: "industry-page-container" },
})
export class IndustryContentComponent implements OnInit, OnDestroy {
  //icons
  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  fasExclamationCircle = fasExclamationCircle;
  faSpinner = faSpinner;
  fasTable = fasTable;
  fasChartLine = fasChartLine;
  fasFileExcel = fasFileExcel;
  fasArrowToBottom = fasArrowToBottom;

  // filters data
  sector;
  industry;
  suggestedLineItems = [];
  lineItemsData;
  tickers = [];
  lineItem = undefined;
  viewBy = ["values"];
  revision = "";
  currency = "";
  periodData: PeriodState = undefined;
  periodUserSetting: PeriodUserSettingObj = undefined;
  showBlankRows = false;
  isIndexToHundreadSelected = false;
  periodsWithAvailableData;
  suggestedLineItemMenuName = "Suggested Line Items";

  //instance variables
  pageShortName = INDUSTRY_PAGE_INFO.kpis.shortName;
  industryId: number;
  compsTableData: CompsTable = {
    rows: [],
    columns: [],
    columnData: {},
    rowData: {},
    filter: {},
    extras: {},
    title: "",
  };
  periodList: Array<string>;
  periodLabel: Array<string>;
  magnitudeMessage;
  companyCount;
  radioValueEstimates;
  dataview: any;
  lineTotalMap = {};
  selectedSector = "";
  selectedIndustry = "";
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "default",
  };
  chartFilters: Dictionary<any> = {};
  tsChartData: any = {};
  tsChartValObj: any = {};
  timeSeriesExportType = "TimeSeries";
  selectedChart = "industry-page-timeseries";
  lineHasTotal = false;
  radioValue = "top10";
  allTickerInfo: Dictionary<any> = {};
  magnitude = "";
  unit: string;
  currencySymbol: string;
  yearTypeFilterVisible = false;
  yearTypeApplied = false;
  yearTypePopoverOpen = false;
  downloadOptVisible = false;
  chartInstance: Highcharts.Chart;
  compChartType = "TimeSeries";
  tabType = "va_comp";
  source = "VA Actuals/Consensus";
  calendar_year = new Date().getFullYear();
  activePeriod = `CY-${new Date().getFullYear()}`;
  tickerPeriodEstimationData = {};
  compTableClassName;
  showMLTableInitialHeight: number;
  showMLActiveStateHeight: number;
  isTableInExpandState = false;
  hasShowMoreButton = false;
  assets = environment.assetUrl;
  apiEP: string = window.apiUrl;
  currencyOptionList: Array<any> = [
    { iso_currency: "USD", symbol: "$" },
    { iso_currency: "EUR", symbol: "$" },
    { iso_currency: "JPY", symbol: "$" },
  ];
  marketCap = [-1];
  region = [-1];
  countries;
  subGroup = -1;
  showBlankRowsLabel = "Show Blank Rows";
  isAbs: boolean;

  //popovers
  isMegaMenuVisible = false;
  isCompExportPopoverVisible = false;
  isNoTickerPopupVisible = false;

  //loader
  isMetaInProgress = true;
  isCompsDataInProgress = true;
  isChartDataInProgress = false;
  isUserSettingUpdateInProgress = false;
  isStdLineItemsUpdateInProgress = false;
  isCompTableExportInProgress = false;
  totalLogicCheckInProgress = false;
  isLineUpdateInProgress = false;

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //urls
  legacyUrl = `${window.caUrl}/app`;

  //subscribers
  routeParamSubscriber: Subscription;
  sectorIndustryStoreSubscriber: Subscription;
  sectorIndustryStoreReloadSubscriber: Subscription;
  sectorIndustryStoreHasDataSubscriber: Subscription;
  sectorMetaSubscriber: Subscription;
  industryDetailsSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  industryMetaSubscriber: Subscription;
  compsDataSubscriber: Subscription;
  totalLineItemLogicCheckSubscriber: Subscription;
  userTabSettingsSubscriber: Subscription;
  userIndustrySettingsSubscriber: Subscription;
  lineItemsSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;

  constructor(
    private dataService: SectorsAndIndustriesPageDataService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    public router: Router,
    private appService: AppService,
    private megaMenuService: MegaMenuService,
    private iconRegistry: VAIconRegistryService,
    private compsDataService: CompsDataService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.iconRegistry.registerIcons([chevronDown, chevronUp]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  /**
   * On initialization, it checks for industry id from routes
   * It resets filters value
   * Make call to get Industry meta and stores it
   */
  ngOnInit() {
    this.routeParamSubscriber = this.route.params.subscribe((paramData) => {
      const industryId = paramData.industryId;
      this.industryId = parseInt(industryId);
      this.subGroup = -1;
      this.region = [-1];
      this.marketCap = [-1];
      this.countries = undefined;
      if (
        this.route.snapshot &&
        this.route.snapshot.data &&
        this.route.snapshot.data.shortName
      ) {
        this.pageShortName = this.route.snapshot.data.shortName;
      }
      if (this.route.snapshot && this.route.snapshot.queryParams) {
        const queryParams = { ...this.route.snapshot.queryParams };
        if (queryParams.subgroup) {
          this.subGroup = parseInt(queryParams.subgroup);
        }
      }
      this.store.dispatch(new DeleteDpParams());
      if (this.sectorIndustryStoreSubscriber) {
        this.sectorIndustryStoreSubscriber.unsubscribe();
      }
      if (this.sectorIndustryStoreReloadSubscriber) {
        this.sectorIndustryStoreReloadSubscriber.unsubscribe();
      }
      if (this.sectorIndustryStoreHasDataSubscriber) {
        this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
      }
      this.sectorIndustryStoreSubscriber = this.store
        .select(stateGetter("sectorIndustry"))
        .subscribe((_sectorIndustryState: SectorIndustry) => {
          if (
            _sectorIndustryState.hasCompaniesData &&
            _sectorIndustryState.facetSelectionSettings
          ) {
            this.industryId =
              _sectorIndustryState.facetSelectionSettings.industry_id;
            this.subGroup = _sectorIndustryState.facetSelectionSettings
              .subindustry_id
              ? _sectorIndustryState.facetSelectionSettings.subindustry_id[0]
              : -1;
            this.marketCap =
              _sectorIndustryState.facetSelectionSettings.market_cap;
            this.region = _sectorIndustryState.facetSelectionSettings.region_id;
            this.countries =
              _sectorIndustryState.facetSelectionSettings.country_id;
          }
          if (_sectorIndustryState.hasData) {
            this.sector = _sectorIndustryState.selectedSectorName;
            if (
              _sectorIndustryState.selectedIndustryId ===
              this.industryId.toString()
            ) {
              this.industry = _sectorIndustryState.selectedIndustryName;
            }
          }
        });

      this.sectorIndustryStoreReloadSubscriber = this.store
        .select(stateGetter("sectorIndustry", "reloadAll"))
        .subscribe((reloadAll: boolean) => {
          if (reloadAll) {
            this.fetchAndUpdateIndustryMeta();
          }
        });

      this.sectorIndustryStoreHasDataSubscriber = this.store
        .select(stateGetter("sectorIndustry", "hasData"))
        .subscribe((_hasData: boolean) => {
          if (!_hasData) {
            if (this.sectorMetaSubscriber) {
              this.sectorMetaSubscriber.unsubscribe();
            }
            this.sectorMetaSubscriber = this.dataService
              .getSectorMeta()
              .subscribe((_sectorMeta: SectorMetaResponse) => {
                const apiCalls = _sectorMeta.sectors.map((_sector) => {
                  return this.dataService.getIndustryDetailsBySector(
                    _sector.sector_id,
                  );
                });

                if (this.industryDetailsSubscriber) {
                  this.industryDetailsSubscriber.unsubscribe();
                }
                this.industryDetailsSubscriber = forkJoin(apiCalls).subscribe(
                  (_industries) => {
                    this.store.dispatch(
                      new SetSectorIndustry({
                        sectors: _sectorMeta,
                        industries: _industries,
                        industryId: this.industryId.toString(),
                        selectedCluster: this.subGroup,
                      }),
                    );
                  },
                );
              });
          }
        });

      this.fetchAndUpdateIndustryMeta();

      this.megaMenuService.updateGlobalMenuLink(this.industryId);
      this.appService.logUserAction(
        {},
        "",
        "",
        ANALYTICS_FEATURE_NAME.kpis,
        {
          tab_name: this.pageShortName,
          industry_id: this.industryId,
        },
        "",
        INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
      );
    });

    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          this.createAndFetchCompTableData();
        }
      });

    this.showMLTableInitialHeight = this.getShowMLTableInitialHeight();
    this.showMLActiveStateHeight = this.getShowMLTableActiveStateHeight();
  }

  /**
   * Unsubscribes from store when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreSubscriber) {
      this.sectorIndustryStoreSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreReloadSubscriber) {
      this.sectorIndustryStoreReloadSubscriber.unsubscribe();
    }
    if (this.sectorIndustryStoreHasDataSubscriber) {
      this.sectorIndustryStoreHasDataSubscriber.unsubscribe();
    }
    if (this.industryDetailsSubscriber) {
      this.industryDetailsSubscriber.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    if (this.industryMetaSubscriber) {
      this.industryMetaSubscriber.unsubscribe();
    }
    if (this.compsDataSubscriber) {
      this.compsDataSubscriber.unsubscribe();
    }
    if (this.totalLineItemLogicCheckSubscriber) {
      this.totalLineItemLogicCheckSubscriber.unsubscribe();
    }
    if (this.userTabSettingsSubscriber) {
      this.userTabSettingsSubscriber.unsubscribe();
    }
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    if (this.currencyMessageSubscriber) {
      this.currencyMessageSubscriber.unsubscribe();
    }
    if (this.userIndustrySettingsSubscriber) {
      this.userIndustrySettingsSubscriber.unsubscribe();
    }
    this.dismissSnackBar();
  }

  //methods
  /**
   * It executes on industry change
   * Makes call to get Industry meta and updates the filters selection data according to it.
   * Makes call to get stdLines Info for the received tickers
   */
  fetchAndUpdateIndustryMeta() {
    this.isMetaInProgress = true;
    // reset filters on change of industry
    this.setDefaultFilters();

    if (this.industryMetaSubscriber) {
      this.industryMetaSubscriber.unsubscribe();
    }
    this.industryMetaSubscriber = this.dataService
      .getIndustryMeta(
        this.industryId,
        this.pageShortName,
        this.subGroup,
        this.region,
        this.marketCap,
        this.countries,
      )
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response["status_code"] === 403) {
          window.location.href = `${this.legacyUrl}/home`;
        }
        if (response.status === "success") {
          const responseData = response.data;
          // store meta information
          this.updateStateWithMeta(responseData);
          this.store.dispatch(
            new SetIndustrySubHeader({
              data: {
                geographies: responseData.geographies,
                marketCaps: responseData.market_caps,
                subGroups: responseData.sub_groups,
              },
              selectedCluster: this.subGroup || -1,
            }),
          );
          if (responseData.ticker_info.length === 0) {
            this.isNoTickerPopupVisible = true;
          } else if (!this.lineItem) {
            this.snackbarInfo.message = "No data Available.";
            this.snackbarInfo.type = "info";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }

          this.isMetaInProgress = false;

          if (
            this.lineItem === undefined ||
            !this.tickers ||
            this.tickers.length === 0
          ) {
            this.isCompsDataInProgress = true;
            this.compsTableData = {
              rows: [],
              columns: [],
              columnData: {},
              rowData: {},
              filter: {},
              extras: {},
              title: "",
            };
            this.chartFilters = this.createChartFilter([], "", "");
            this.isCompsDataInProgress = false;
          } else {
            // make data calls
            this.createAndFetchCompTableData(true);
            const tickerIds = this.tickers.map((item) => item.ticker);
            this.getPeriodsWithAvailableData(tickerIds);
          }
        }
      });
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    this.lineItem = meta.lineitem ? meta.lineitem[0] : undefined;
    if (this.lineItem) {
      this.lineItem.label = this.lineItem.name;
    }
    this.currency = meta.currency || "USD";
    this.suggestedLineItems = meta.suggested_line_info
      ? meta.suggested_line_info.map((item) => {
          return {
            ...item,
            label: item.name,
            sli_id_count: item.sli_id_count || item.count,
            id: item.uniquesliid,
            disabled: false,
            isLeaf: true,
            level: 2,
            header: false,
            isCollapsed: true,
            isSelected:
              this.lineItem && this.lineItem.uniquesliid === item.uniquesliid,
          };
        })
      : [];
    this.tickers = meta.ticker_info || [];
    this.periodData = meta.period;
    const periodUserSettings = convertPeriodMetaToUserSettings(meta.period);
    this.periodUserSetting = periodUserSettings;
    this.periodList = getSelectedPeriods(meta.period, true, false);
    const periodTypeId = periodUserSettings.type;
    const selectedBasisId =
      this.periodData &&
      this.periodData.period_basis &&
      this.periodData.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            this.periodData.period_basis[periodTypeId].from_basis,
          )
        : undefined;
    const isYearlyBasisId = isBasisFullYear(selectedBasisId);
    this.periodLabel =
      periodTypeId === "rel"
        ? this.periodList.map((item) =>
            convertRelativePeriodIdToLabel(item, isYearlyBasisId),
          )
        : this.periodList;
    this.companyCount = meta.company_count;
    this.magnitudeMessage = meta.magnitude_message;
    this.viewBy = meta.view_by;
    this.revision = meta.revision;
    this.dataview = {
      view_by: [...this.viewBy],
      revision: this.revision,
    };
    this.isIndexToHundreadSelected = meta.index_to_100;
    this.showBlankRows = meta.show_blank_rows;

    // reset the selected line item if no tickers available
    if (this.lineItem && (!meta.ticker_info || !meta.ticker_info.length)) {
      this.lineItem = undefined;
    }

    // set Active period
    this.setActiveAndEstimatedPeriod();
  }

  /**
   * reset filters selection
   */
  setDefaultFilters() {
    this.suggestedLineItems = [];
    this.lineItemsData;
    this.tickers = [];
    this.lineItem = undefined;
    this.viewBy = [];
    this.revision = "";
    this.currency = "";
    this.periodData = undefined;
    this.periodUserSetting = undefined;
    this.showBlankRows = false;
    this.hasShowMoreButton = false;
    this.showBlankRowsLabel = "Show Blank Rows";
  }

  /**
   * Makes api call to get lineitems according to tickers.
   * Formats the response object, so that it can be used in `LineItemSearch` component
   * @param {array} tickers - array of ticker id
   * @param {boolean} showSuggestedLineItems - flag to fetch suggested line items or not
   * @param {string} currency - currency info
   */
  fetchAndUpdateStdLineItems(
    tickers: Array<string>,
    showSuggestedLineItems = false,
    currency?: string,
  ) {
    this.isStdLineItemsUpdateInProgress = true;
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    this.lineItemsSubscriber = this.dataService
      .getStdLineItems(tickers, showSuggestedLineItems, currency)
      .subscribe((response) => {
        if (response.status === "success") {
          const stdData = response.data;
          const formattedStdLineItems = [];
          if (this.suggestedLineItems) {
            const suggestLineItems = {
              tab_full_name: this.suggestedLineItemMenuName,
              tab_short_name: "SL",
              tab_sli_data: this.suggestedLineItems,
            };
            formattedStdLineItems.push(suggestLineItems);
          }
          for (const item of stdData) {
            const formattedTabSliData = [];
            // format the tab_sli_data to match data shape of lineItems required for LineitemSearchComponent component
            for (const lineItem of item.tab_sli_data) {
              formattedTabSliData.push({
                ...lineItem,
                label: lineItem.name,
                sli_id_count: lineItem.sli_id_count,
                id: lineItem.uniquesliid,
                disabled: false,
                isLeaf: true,
                level: 2,
                header: false,
                isCollapsed: true,
              });
            }
            const currentItem = {
              tab_full_name: item.tab_full_name,
              tab_short_name: item.tab_short_name,
              tab_sli_data: formattedTabSliData,
            };
            formattedStdLineItems.push(currentItem);
          }
          this.lineItemsData = formattedStdLineItems;
        }
        this.isStdLineItemsUpdateInProgress = false;
      });
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  /**
   * Returns array of tickers id from array of tickers object.
   * @returns {array} - array of ticker id
   */
  getTickerIdArray() {
    return this.compsTableData && this.compsTableData.rows
      ? this.compsTableData.rows.map((item) => item.ticker)
      : [];
  }

  /**
   * Creates comp table data according to selected filters.
   */
  createAndFetchCompTableData(getStdLineItemData = false) {
    if (!this.lineItem) {
      return;
    }
    const dummyLineItemInfo: Dictionary<any> = {};
    dummyLineItemInfo[this.lineItem && this.lineItem.uniquesliid] = {
      magnitude: this.lineItem.magnitude || "M",
      unit: this.lineItem.unit || "Amount",
    };
    const periodType = getPeriodTypeDataId(this.periodData);

    this.compsTableData = createCompsTable(
      this.tickers.map((tickerInfo) => {
        return {
          full_name: tickerInfo.full_name,
          ticker: tickerInfo.ticker,
          sli_comps_id: tickerInfo.companyid,
        };
      }),
      {
        fuzzysli: 0,
        name: this.lineItem && this.lineItem.name,
        is_valuation_ratio: this.lineItem && this.lineItem.is_valuation_ratio,
        period: this.periodList,
        periodLabel: this.periodLabel,
        sli_comps_id: this.lineItem && this.lineItem.uniquesliid,
        sli_id: this.lineItem && this.lineItem.uniquesliid,
        source: "VA Actuals/Consensus",
      },
      dummyLineItemInfo,
      this.magnitudeMessage,
      this.viewBy,
      this.revision,
      "VA Actuals/Consensus",
      this.currency,
      this.lineHasTotal,
      this.periodData,
    );
    let madeGetStdLineItemDataCallOnce = false;
    if (this.lineTotalMap[this.lineItem.uniquesliid] === undefined) {
      this.getLineTotalLogicAndUpdateData(
        this.lineItem && this.lineItem.uniquesliid,
        getStdLineItemData,
      );
      madeGetStdLineItemDataCallOnce = true;
      return;
    }
    this.lineHasTotal =
      this.lineItem && this.lineTotalMap[this.lineItem.uniquesliid];
    if (!this.lineHasTotal && this.radioValue === "total") {
      this.radioValue = "top10";
    }
    this.compsTableData.filter = createCompsTableFilter(
      this.viewBy,
      this.revision,
      "VA Actuals/Consensus",
      this.currency,
      this.lineHasTotal,
    );
    this.fetchAndHandleCompsData(
      this.viewBy,
      this.revision,
      this.getTickerIdArray(),
      this.periodList,
      this.lineItem && this.lineItem.uniquesliid,
      "VA Actuals/Consensus",
      this.currency,
      periodType,
    );

    if (
      !madeGetStdLineItemDataCallOnce &&
      getStdLineItemData &&
      this.tickers &&
      this.tickers.length
    ) {
      // Update stdLineItem on Tickers change
      const tickersWithOnlyId = this.tickers.map((item) => item.ticker);

      this.fetchAndUpdateStdLineItems(tickersWithOnlyId, false);
    }
  }

  /**
   * Check if line can be totalled or not and updates the comptable data according to selected lineitem
   * Resets the charts filter to `top10`, if line can't be totalled
   * Caches if line can be totalled or not in `lineTotalMap` object
   * @param {string} lineId - selected lineitem id
   */
  getLineTotalLogicAndUpdateData(lineId, getStdLineItemData) {
    this.totalLogicCheckInProgress = true;
    const periodType = getPeriodTypeDataId(this.periodData);
    if (this.totalLineItemLogicCheckSubscriber) {
      this.totalLineItemLogicCheckSubscriber.unsubscribe();
    }
    this.totalLineItemLogicCheckSubscriber = this.dataService
      .getTotalLogic(lineId)
      .subscribe((res) => {
        if (res["status"] === "success") {
          const canBeTotalled = res["total"][lineId];
          this.lineHasTotal = canBeTotalled;
          this.lineTotalMap[lineId] = canBeTotalled;
          if (!canBeTotalled && this.radioValue === "total") {
            this.radioValue = "top10";
          }

          this.compsTableData.filter = createCompsTableFilter(
            this.viewBy,
            this.revision,
            "VA Actuals/Consensus",
            this.currency,
            this.lineHasTotal,
          );
          this.fetchAndHandleCompsData(
            this.viewBy,
            this.revision,
            this.getTickerIdArray(),
            this.periodList,
            lineId,
            "VA Actuals/Consensus",
            this.currency,
            periodType,
          );
        }
        this.totalLogicCheckInProgress = false;

        if (getStdLineItemData && this.tickers && this.tickers.length) {
          // Update stdLineItem on Tickers change
          const tickersWithOnlyId = this.tickers.map((item) => item.ticker);

          this.fetchAndUpdateStdLineItems(tickersWithOnlyId, false);
        }
      });
  }

  /**
   * Updates the magnitude and unit in compsTableData
   * @param {string} magnitude
   * @param {string} unit
   */
  updateLineInfo(magnitude: string, unit: string) {
    const newColumnData: Dictionary<CompsTableColumnData> = {};

    Object.keys(this.compsTableData.columnData).forEach((key: string) => {
      newColumnData[key] = {
        ...this.compsTableData.columnData[key],
        unit: unit,
        magnitude: magnitude,
      };
    });

    this.compsTableData = {
      ...this.compsTableData,
      columnData: newColumnData,
    };
  }

  /**
   * Creates the required data for comp table
   * It makes multiple api calls to get comps data. Each call payload contains max 5 tickers.
   * It sets the comptable's rowData, lineitems's magnitude, unit, currency and chart filters.
   * @param {array} viewBy -  array of (values | yoy | revision)
   * @param {string} revision - revision value
   * @param {array} tickers - array of ticker id
   * @param {array} periods - range of period
   * @param {string} uniquesliid - selected lineitem id
   * @param {string} source - selected source
   * @param {string} currency - selected currency
   */
  fetchAndHandleCompsData(
    viewBy: Array<string>,
    revision: string,
    tickers: Array<string>,
    periods: Array<string>,
    uniquesliid: string,
    source: string,
    currency: string,
    periodType: string,
  ) {
    const prevPeriods = [];
    const otherPrevPeriods = [];
    this.isAbs = this.periodUserSetting["type"] === "abs";
    if (viewBy.includes("yoy")) {
      for (const period of periods) {
        if (otherPrevPeriods.length === 2 && prevPeriods.length === 4) {
          break;
        }
        let prevPeriod = "";
        if (period !== "LTM") {
          if (period === "NTM") {
            prevPeriod = "LTM";
            otherPrevPeriods.push(prevPeriod);
          } else if (period === "STM") {
            prevPeriod = "NTM";
            otherPrevPeriods.push(prevPeriod);
          } else {
            if (prevPeriods.length < 4) {
              if (this.isAbs) {
                const [basis, year] = period.toString().split("-");
                prevPeriod = `${basis}-${parseInt(year) - 1}`;
              } else {
                const basis = period.toString().replace(/[0-9-]/g, "");
                const year = period.toString().replace(/[a-zA-Z]/g, "");
                if (basis.includes("Q")) {
                  prevPeriod = basis + (parseInt(year) - 4);
                } else if (basis.includes("H")) {
                  prevPeriod = basis + (parseInt(year) - 2);
                } else {
                  prevPeriod = basis + (parseInt(year) - 1);
                }
              }
              prevPeriods.push(prevPeriod);
            }
          }
        }
      }
      periods = [...new Set([...periods, ...prevPeriods, ...otherPrevPeriods])];
    }

    this.isCompsDataInProgress = true;
    if (tickers.length === 0) {
      this.chartFilters = this.createChartFilter([], "", "");
      this.hasShowMoreButton = false;
    }

    const dataCalls: Array<Observable<any>> = [];

    let _viewBy = "viewBy=values";
    let _dataExistsCheck = "";
    if (viewBy.includes("values")) {
      _dataExistsCheck += `&data_exists_check=values`;
    }
    if (viewBy.includes("revision")) {
      _viewBy += `&viewBy=revision&revision=${revision}`;
      _dataExistsCheck += `&data_exists_check=revision`;
    } else if (viewBy.includes("yoy")) {
      _viewBy += `&viewBy=yoy`;
      _dataExistsCheck += `&data_exists_check=yoy`;
    }
    let currencyUrl = "";
    if (currency !== "Base") {
      currencyUrl += `&currency=${currency}`;
    }

    const tickersChunks = getTickersChunksForDataCall(tickers, 20);

    for (let i = 0; i < tickersChunks.length; i++) {
      const tickerParams = getTickerIdUrl(tickersChunks[i]);
      const periodList = periods.join("&period=");
      let url = `${_viewBy}${_dataExistsCheck}${tickerParams}${currencyUrl}&industry_id=${this.industryId}&version=v2`;
      url = `${url}&period=${periodList}`;
      url = `${url}&period_type=${periodType}`;
      url = `${url}&uniquesliid=${uniquesliid}&source=${encodeURIComponent(
        source,
      )}`;
      dataCalls.push(this.compsDataService.getCompsData(url));
    }

    if (this.compsDataSubscriber) {
      this.compsDataSubscriber.unsubscribe();
    }
    this.compsDataSubscriber = forkJoin(dataCalls).subscribe((reponseList) => {
      const lineInfo: Dictionary<any> = {};
      let currencySymbol = "";
      reponseList.forEach((res) => {
        if (res.status === "success") {
          Object.keys(res.data).forEach((ticker) => {
            this.allTickerInfo[ticker] = { ...res.data[ticker] };
            if (this.allTickerInfo[ticker]) {
              if (this.allTickerInfo[ticker][`${uniquesliid}|U`]) {
                lineInfo.unit = this.allTickerInfo[ticker][`${uniquesliid}|U`];
                this.unit = this.allTickerInfo[ticker][`${uniquesliid}|U`];
              }
              if (this.allTickerInfo[ticker][`${uniquesliid}|M`]) {
                lineInfo.magnitude =
                  this.allTickerInfo[ticker][`${uniquesliid}|M`];
                this.magnitude = this.allTickerInfo[ticker][`${uniquesliid}|M`];
              }
              if (this.allTickerInfo[ticker][`${uniquesliid}|C`]) {
                currencySymbol = this.allTickerInfo[ticker][`${uniquesliid}|C`];
              }
            }

            // estimated period handling
            if (res.data[ticker] && res.data[ticker][uniquesliid]) {
              this.tickerPeriodEstimationData[ticker] = [];
              for (let i = 0; i < this.periodList.length; i++) {
                const item = this.periodList[i];
                if (res.data[ticker][uniquesliid][item]) {
                  if (res.data[ticker][uniquesliid][item].is_forecast) {
                    this.tickerPeriodEstimationData[ticker].push(`${item}E`);
                  } else {
                    this.tickerPeriodEstimationData[ticker].push(item);
                  }
                }
              }
            }
          });
        }
      });
      this.updateLineInfo(this.magnitude, lineInfo.unit);

      const { rowData, tickersWithDataCount } = createTimeseriesCompsTableRows(
        this.compsTableData.rows,
        this.allTickerInfo,
        uniquesliid,
        periods,
        this.compsTableData.columnData[periods[0]].unit,
      );
      const tickerWithoutData =
        this.tickers.length - (tickersWithDataCount || 0);
      this.showBlankRowsLabel = `Show ${tickerWithoutData} Blank Rows`;

      this.compsTableData.rowData = rowData;

      // this.magnitude = lineInfo.magnitude;
      this.currencySymbol = currencySymbol;

      //update comps table data if remove blanks true , keep it at the end
      this.updateDataOnShowBlankSwitchChange(this.showBlankRows);
      this.isCompsDataInProgress = false;

      this.appService.logUserAction(
        {},
        "",
        "",
        "INDUSTRY_KPI_COMPS_DATA",
        {
          tab_name: this.pageShortName,
          industry_id: this.industryId,
          tickers: tickers,
          source: this.source,
          period: this.periodUserSetting,
          currency: currency,
          view_by: viewBy,
          revision: revision,
          remove_blanks: this.showBlankRows,
          lineItem: getFormattedLineItemForTracking([this.lineItem]),
        },
        "",
        INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
      );
    });
  }

  ngAfterViewInit() {
    this.checkIfShowMoreLessExist();
  }

  setActiveAndEstimatedPeriod() {
    if (this.periodUserSetting) {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonthIndex = currentDate.getMonth();
      const isAbsPeridType = this.periodUserSetting.type === "abs";
      let seletedColumn = "";
      if (this.periodUserSetting.period_type_basis_from === "Y") {
        if (isAbsPeridType) {
          seletedColumn = `${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["abs"].year
          }${currentYear}`;
        } else {
          seletedColumn = `${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["rel"].year
          }0`;
        }
      } else if (this.periodUserSetting.period_type_basis_from === "Q") {
        if (isAbsPeridType) {
          const currentCompletedQuarter =
            Math.floor(currentMonthIndex / 3) === 0
              ? 4
              : Math.floor(currentMonthIndex / 3);
          seletedColumn = `${currentCompletedQuarter}${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["abs"].quarter
          }${currentCompletedQuarter === 4 ? currentYear - 1 : currentYear}`;
        } else {
          seletedColumn = `${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["rel"].quarter
          }0`;
        }
      } else if (this.periodUserSetting.period_type_basis_from === "H") {
        if (isAbsPeridType) {
          const currentCompletedHalfYear =
            Math.floor(currentMonthIndex / 6) === 0
              ? 2
              : Math.floor(currentMonthIndex / 6);
          seletedColumn = `${currentCompletedHalfYear}${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["abs"]
              .halfYear
          }${currentCompletedHalfYear === 2 ? currentYear - 1 : currentYear}`;
        } else {
          seletedColumn = `${
            PERIOD_DISPLAY_PREFIXES[this.periodUserSetting.basis]["rel"]
              .halfYear
          }0`;
        }
      }
      const currenPeriodExists = this.periodList.includes(seletedColumn);
      if (!currenPeriodExists) {
        seletedColumn = this.periodList[0];
      }
      this.activePeriod = seletedColumn;
      if (
        !this.radioValueEstimates ||
        !this.periodList.includes(this.radioValueEstimates)
      ) {
        this.radioValueEstimates = this.activePeriod;
      }
    }
  }

  /**
   * Checks if show more or less button for comp table exist depending on the scrollable height of table and initial height(40% of viewport)
   */
  checkIfShowMoreLessExist() {
    const compTableScrollableElement: HTMLElement = document.querySelector(
      `.${this.compTableClassName}`,
    );
    if (compTableScrollableElement) {
      const compScrollHeight = compTableScrollableElement.scrollHeight;
      const compInitialHeight = this.showMLTableInitialHeight;
      const existShowML = compScrollHeight > compInitialHeight + 20; // 20 px buffer, for scrollbar height or less difference
      this.hasShowMoreButton = existShowML;
    }
  }

  /**
   * Fires on the click of Show more or less button, It toggles expand and collapse state of table.
   * Scrolls to the top on click of Show more button
   */
  handleShowMLClick() {
    if (!this.isTableInExpandState) {
      this.scrollToTop();
    }
    this.isTableInExpandState = !this.isTableInExpandState;
  }

  /**
   * Scroll to the top of the page
   */
  scrollToTop() {
    const scrollableLayout = document.querySelector(".ant-layout-content");
    if (scrollableLayout) {
      scrollableLayout.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  getFormattedTickerInfo(tickers) {
    return tickers.map((tickerInfo) => {
      return {
        full_name: tickerInfo.full_name,
        ticker: tickerInfo.ticker,
        sli_comps_id: tickerInfo.companyid,
      };
    });
  }

  /**
   * It filters the compTableData on the basis of remove blanks switch value
   * If it is true it filters the tickers which have data for all periods
   * @param {boolean} value - elected value of remove blank
   */
  updateDataOnShowBlankSwitchChange(value) {
    this.isCompsDataInProgress = true;

    if (!value) {
      const currentLineItemId =
        this.lineItem && this.lineItem.uniquesliid
          ? this.lineItem.uniquesliid
          : "";
      const filterTickersWithBlankValues =
        this.compsTableData.rows.filter(
          (item) =>
            this.compsTableData &&
            this.compsTableData.rowData &&
            this.compsTableData.rowData[item.ticker] &&
            this.compsTableData.rowData[item.ticker][
              `${currentLineItemId}|data_exists`
            ],
        ) || [];
      this.compsTableData = {
        ...this.compsTableData,
        rows: filterTickersWithBlankValues,
      };
      this.compsTableData = this.appService.superClone(this.compsTableData);
    } else {
      this.compsTableData = {
        ...this.compsTableData,
        rows: this.getFormattedTickerInfo(this.tickers),
      };
    }

    computeTotal(
      this.compsTableData,
      true,
      "",
      this.currency,
      value,
      this.isAbs,
    );
    computeAverage(this.compsTableData, true, "", this.currency, value);

    this.compsTableData = {
      ...this.compsTableData,
    };

    this.isCompsDataInProgress = false;

    setTimeout(() => {
      this.checkIfShowMoreLessExist();
    }, 10);

    const viewByKey = this.getViewByKey();

    const topTenTickers = this.getTopTenTickers(
      this.lineItem.uniquesliid,
      this.activePeriod,
      viewByKey,
    );
    this.chartFilters = this.createChartFilter(
      topTenTickers,
      this.currencySymbol,
      viewByKey,
    );
  }

  /**
   * Return viewBy key for charts
   * @returns {string} - viewBy
   */
  getViewByKey(): string {
    if (this.revision && this.revision.length > 0) {
      return "values";
    }
    if (this.viewBy.length === 1 && this.viewBy[0] === "yoy") {
      return "yoy";
    }
    return "values";
  }

  /**
   * Creates chart data by using comptable data
   * This is used when viewBy is value or yoy. This way we creates chart data using comptable instead of making chart api calls
   * @param {CompsTableRow} rows - rows info from compTableData
   * @param {any} allTickerInfo - all ticker info
   * @param {string} lineId - selected lineitem id
   * @param {object} lineInfo - selected lineitem
   * @param {string} currency - selected currency
   * @param {array} periods - range of period
   * @param {string} viewBy - values | yoy | revision
   * @param {array} estimatedPeriods - range of period with Estimation info
   */
  createTimeseriesChartData(
    rows: Array<CompsTableRow>,
    allTickerInfo: Dictionary<any>,
    lineId: string,
    lineInfo: Dictionary<any>,
    periods: Array<string>,
    viewBy: string,
    estimatedPeriods: Array<string>,
  ): Dictionary<any> {
    if (this.radioValue === "top10" || this.radioValue === "top5") {
      const valObj = {};
      const typeObj = {};
      const indexObj = {};
      const tsXdata = [];
      valObj[lineId] = {};
      valObj[lineId][this.getViewByKey()] = {};
      typeObj[lineId] = {};
      indexObj[lineId] = {};
      indexObj[lineId][this.getViewByKey()] = {};
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const rowObj = allTickerInfo[row.ticker] || {};
        const data = [];
        const type = [];
        const indexValues = [];
        let baseValue = null;
        // const addPeriodData = !this.tsPeriods.length;
        for (let j = 0; j < periods.length; j++) {
          const p = periods[j];
          tsXdata.push(p);
          const valueExists =
            rowObj[lineId] &&
            rowObj[lineId][p] &&
            !isNaN(rowObj[lineId][p][viewBy]);
          const value = valueExists
            ? roundToTwo(rowObj[lineId][p][viewBy])
            : undefined;
          const typeVal = rowObj[lineId]
            ? rowObj[lineId][p]
              ? rowObj[lineId][p].is_forecast === true
                ? "Consensus"
                : "VA Actuals"
              : undefined
            : undefined;
          let indexValue = null;
          if (valueExists) {
            const currentValue = rowObj[lineId][p][viewBy];
            if (
              typeof baseValue !== "number" &&
              typeof currentValue === "number"
            ) {
              baseValue = currentValue < 0 ? currentValue * -1 : currentValue;
            }
            indexValue = roundToTwo((currentValue / baseValue) * 100);
          }

          data.push(value);
          type.push(typeVal);
          indexValues.push(indexValue);
          // if (typeVal !== undefined) {
          //   type.push(typeVal);
          // }
        }
        valObj[lineId][this.getViewByKey()][row.ticker] = data;
        typeObj[lineId][row.ticker] = type;
        indexObj[lineId][this.getViewByKey()][row.ticker] = indexValues;
      }
      this.tsChartValObj = typeObj;

      return { absValues: valObj, indexValues: indexObj };
    }
    if (this.radioValue === "average") {
      const average = [];
      const averageIndexValueArr = [];
      let averageBaseValue = null;
      let averageIndexValue = null;
      periods.forEach((colKey) => {
        const currentAverageValueExist =
          this.compsTableData.columnData[colKey] &&
          !isNaN(this.compsTableData.columnData[colKey].average[viewBy]);
        if (currentAverageValueExist) {
          const currentValue =
            this.compsTableData.columnData[colKey].average[viewBy];
          average.push(currentValue);
          if (
            typeof averageBaseValue !== "number" &&
            typeof currentValue === "number"
          ) {
            averageBaseValue =
              currentValue < 0 ? currentValue * -1 : currentValue;
          }
          averageIndexValue = roundToTwo(
            (currentValue / averageBaseValue) * 100,
          );
          averageIndexValueArr.push(averageIndexValue);
        } else {
          average.push(undefined);
          averageIndexValueArr.push(undefined);
        }
      });

      const periodTypes = [];
      for (let i = 0; i < estimatedPeriods.length; i++) {
        const item = estimatedPeriods[i];
        if (item.includes("E")) {
          periodTypes.push("Consensus");
        } else {
          periodTypes.push("VA Actuals");
        }
      }

      this.tsChartValObj = {
        [lineId]: {
          [`Average - ${lineInfo[lineId].name}`]: periodTypes,
        },
      };
      const averageObj = {
        absolute: {
          [lineId]: {
            [this.getViewByKey()]: {
              [`Average - ${lineInfo[lineId].name}`]: average,
            },
          },
        },
        index: {
          [lineId]: {
            [this.getViewByKey()]: {
              [`Average - ${lineInfo[lineId].name}`]: averageIndexValueArr,
            },
          },
        },
      };
      return {
        absValues: averageObj.absolute,
        indexValues: averageObj.index,
      };
    }
    //totals scenario
    const totals = [];
    const totalIndexValueArr = [];
    let totalBaseValue = null;
    let totalIndexValue = null;
    periods.forEach((colKey) => {
      const currenttotalValueExist =
        this.compsTableData.columnData[colKey] &&
        !isNaN(this.compsTableData.columnData[colKey].total[viewBy]);
      if (currenttotalValueExist) {
        const currentValue =
          this.compsTableData.columnData[colKey].total[viewBy];
        totals.push(currentValue);
        if (
          typeof totalBaseValue !== "number" &&
          typeof currentValue === "number"
        ) {
          totalBaseValue = currentValue < 0 ? currentValue * -1 : currentValue;
        }
        totalIndexValue = roundToTwo((currentValue / totalBaseValue) * 100);
        totalIndexValueArr.push(totalIndexValue);
      } else {
        totals.push(undefined);
        totalIndexValueArr.push(undefined);
      }
    });

    const periodTypes = [];
    for (let i = 0; i < estimatedPeriods.length; i++) {
      const item = estimatedPeriods[i];
      if (item.includes("E")) {
        periodTypes.push("Consensus");
      } else {
        periodTypes.push("VA Actuals");
      }
    }
    this.tsChartValObj = {
      [lineId]: {
        [`Total - ${lineInfo[lineId].name}`]: periodTypes,
      },
    };
    const totalObj = {
      absolute: {
        [lineId]: {
          [this.getViewByKey()]: {
            [`Total - ${lineInfo[lineId].name}`]: totals,
          },
        },
      },
      index: {
        [lineId]: {
          [this.getViewByKey()]: {
            [`Total - ${lineInfo[lineId].name}`]: totalIndexValueArr,
          },
        },
      },
    };
    return {
      absValues: totalObj.absolute,
      indexValues: totalObj.index,
    };
  }

  /**
   * Creates chart filters and data info for chart
   */
  createChartFilter(tickerInfo, currSymbol, viewBy): Dictionary<any> {
    this.selectedChart = this.getSelectedChart(
      this.revision && this.revision.length > 0,
      this.radioValue,
    );
    const sliceLength = this.getSliceLength(this.radioValue);
    const selectedTickersId = this.getTickerIdArray();
    const selectedTickers = this.getChartFilterTickers(
      this.radioValue,
      tickerInfo,
      this.lineItem,
    ).slice(0, sliceLength);
    const chartFilterObj = {
      chartId: "current",
      currency: this.currency,
      tickers: selectedTickers,
      selectedTickersInfo: this.getChartFilterSelectedTickerInfo(
        this.radioValue,
        tickerInfo,
        this.lineItem,
      ).slice(0, sliceLength),
      lineInfo: {
        [this.lineItem && this.lineItem.uniquesliid]: {
          name: this.lineItem && this.lineItem.name,
          uniqueSliId: this.lineItem && this.lineItem.uniquesliid,
          unit: this.unit,
          magnitude: this.magnitude,
          currSymbol: currSymbol,
        },
      },
      lines: [this.lineItem && this.lineItem.uniquesliid],
      scaleType: this.isIndexToHundreadSelected ? 2 : 1,
      dataView: this.getViewByKey(),
      viewBy: viewBy,
      dataReady: false,
      tickerIds:
        this.radioValue === "average" || this.radioValue === "total"
          ? selectedTickersId
          : selectedTickersId.slice(0, sliceLength), //ticker id aren't available in case of total and average, hence creating new property
      respectivePeriodData: {},
      periodType:
        this.periodUserSetting.type === "rel" ? "relative" : "absolute",
    };

    if (
      this.selectedChart === "industry-page-revision" ||
      this.selectedChart === "industry-page-total-revision" ||
      this.selectedChart === "industry-page-average-revision"
    ) {
      let twoYearBackFormattedDate = "24m";
      if (
        this.selectedChart === "industry-page-revision" &&
        this.revision === "2y"
      ) {
        const twoYearBack = new Date(
          new Date().setFullYear(new Date().getFullYear() - 2),
        );

        twoYearBackFormattedDate = `custom|${this.getFormattedDate(
          twoYearBack,
        )}`;
      }

      return {
        ...chartFilterObj,
        revisionPeriod:
          this.revision === "1y" ? "12m" : twoYearBackFormattedDate,
        companyids: selectedTickersId.map(
          (item) =>
            (this.tickers.find((el) => item === el.ticker) || {}).companyid,
        ),
        industryId: this.industryId,
        dataReady: true,
        periods: [this.radioValueEstimates],
      };
    }

    const tsSelectedPeriods = this.tsYearFormatting(
      this.periodList,
      this.allTickerInfo,
      this.getTickerIdArray(),
      this.lineItem && this.lineItem.uniquesliid,
    );
    const tsSelectedPeriodWithoutEstimationPostfix = tsSelectedPeriods.map(
      (item) => item.replace("E", ""),
    );
    const tsPeriods = {
      from: tsSelectedPeriodWithoutEstimationPostfix[0],
      to: tsSelectedPeriodWithoutEstimationPostfix[
        tsSelectedPeriodWithoutEstimationPostfix.length - 1
      ],
    };
    const { absValues, indexValues } = this.createTimeseriesChartData(
      this.compsTableData.rows,
      this.allTickerInfo,
      this.lineItem && this.lineItem.uniquesliid,
      chartFilterObj.lineInfo,
      tsSelectedPeriodWithoutEstimationPostfix,
      viewBy,
      tsSelectedPeriods,
    );
    return {
      ...chartFilterObj,
      chartTypeId: "2",
      periods: tsPeriods,
      absVal: absValues,
      indexVal: indexValues,
      x: tsSelectedPeriods,
      respectivePeriodData: {
        [this.lineItem && this.lineItem.uniquesliid]:
          this.tickerPeriodEstimationData,
      },
      typeVal: this.tsChartValObj,
      dataReady: true,
    };
  }

  /**
   * Formats the period for timeseries chart.
   * It adds `CY` prefix and `E` postfix to year
   * @param {array} periods - formatted period array for charts
   * @param {any} allTickerInfo - all ticker info
   * @param {array} tickers - array of ticker id
   * @param {string} lineId - selected lineitem id
   * @returns {array} - formatted period array for charts
   */
  tsYearFormatting(
    periods: Array<string>,
    allTickerInfo: Dictionary<any>,
    tickers: Array<string>,
    lineId: string,
  ) {
    const result = [];
    for (let i = 0; i < periods.length; i++) {
      const p = periods[i];
      let periodStr = `${p}`;
      let periodExist = false;
      for (let j = 0; j < tickers.length; j++) {
        const t = tickers[j];
        if (
          allTickerInfo[t] &&
          allTickerInfo[t][lineId] &&
          allTickerInfo[t][lineId][p] &&
          allTickerInfo[t][lineId][p][this.viewBy[0]]
        ) {
          periodExist = true;
          if (allTickerInfo[t][lineId][p].is_forecast) {
            periodStr = `${p}E`;
            break;
          }
        }
      }
      // if (periodStr === "") {
      //   //forecast details for period is not present. Fallback to va actuals
      //   periodStr = `${p}`;
      // }

      if (periodExist) {
        result.push(periodStr);
      }
    }
    return result;
  }

  /**
   * Determines the top ten tickers from the list of the tickers for given year.
   * @param {string} uniquesliid - id of lineitem
   * @param {string} period - year
   * @param {string} viewBy - viewBy value
   * @returns {array} - top 10 tickers according to viewBy value
   */
  getTopTenTickers(
    uniquesliid: string,
    period: string,
    viewBy: string,
  ): Array<Dictionary<any>> {
    const sortedTickers = [...this.compsTableData.rows];

    sortedTickers.sort((ticker1: CompsTableRow, ticker2: CompsTableRow) => {
      const a =
        this.compsTableData.rowData[ticker1.ticker] &&
        this.compsTableData.rowData[ticker1.ticker][uniquesliid] &&
        this.compsTableData.rowData[ticker1.ticker][uniquesliid][period] &&
        this.compsTableData.rowData[ticker1.ticker][uniquesliid][period][
          viewBy
        ] !== undefined
          ? this.compsTableData.rowData[ticker1.ticker][uniquesliid][period][
              viewBy
            ]
          : -99999;

      const b =
        this.compsTableData.rowData[ticker2.ticker] &&
        this.compsTableData.rowData[ticker2.ticker][uniquesliid] &&
        this.compsTableData.rowData[ticker2.ticker][uniquesliid][period] &&
        this.compsTableData.rowData[ticker2.ticker][uniquesliid][period][
          viewBy
        ] !== undefined
          ? this.compsTableData.rowData[ticker2.ticker][uniquesliid][period][
              viewBy
            ]
          : -99999;
      if (a > b) {
        return -1;
      }
      if (a === b) {
        return 0;
      }
      return 1;
    });

    return sortedTickers.slice(0, 10);
  }

  /**
   * Determines the type of chart.
   * @param {boolean} isRevision - if the viewType is revision or not
   * @param {string} chartOption - selected charts radio value
   * @returns {string} - type [industry-page-revision | industry-page-total-revision | industry-page-timeseries] of the chart
   */
  getSelectedChart(isRevision, chartOption): string {
    if (isRevision === true) {
      if (chartOption === "top10" || chartOption === "top5") {
        return "industry-page-revision";
      }
      if (chartOption === "total") {
        return "industry-page-total-revision";
      }
      return "industry-page-average-revision";
    }
    return "industry-page-timeseries";
  }

  /**
   * Returns the tickers ids according to selected chart filter
   * @param {string} radioValue - selected chart filter
   * @param {array} tickerInfo - array of tickers
   * @param {object} selectedLineItem - lineitem
   * @returns {array} - array of ticker ids which will be used for chart
   */
  getChartFilterTickers(radioValue, tickerInfo, selectedLineItem): Array<any> {
    if (selectedLineItem === undefined) {
      return [];
    }
    if (radioValue === "total") {
      return [`Total - ${selectedLineItem.name}`];
    }
    if (radioValue === "average") {
      return [`Average - ${selectedLineItem.name}`];
    }
    return tickerInfo.map((_tickerInfo) => _tickerInfo.ticker);
  }

  /**
   * Returns the tickers info according to selected chart filter
   * @param {string} radioValue - selected chart filter
   * @param {array} tickerInfo - array of tickers
   * @param {object} selectedLineItem - lineitem
   * @returns {array} - array of tickers which will be used for chart
   */
  getChartFilterSelectedTickerInfo(
    radioValue,
    tickerInfo,
    selectedLineItem,
  ): Array<any> {
    if (selectedLineItem === undefined) {
      return [];
    }
    if (radioValue === "total") {
      return [
        {
          name: [`Total - ${selectedLineItem.name}`],
          ticker: "Total",
        },
      ];
    }
    if (radioValue === "average") {
      return [
        {
          name: [`Average - ${selectedLineItem.name}`],
          ticker: "Average",
        },
      ];
    }
    return tickerInfo.map((_tickerInfo) => {
      return {
        name: _tickerInfo.full_name,
        ticker: _tickerInfo.ticker,
      };
    });
  }

  /**
   * Returns the periods according to chart type
   * @returns {array | object} - period data for charts
   */
  getChartFilterPeriods(): any {
    if (
      this.selectedChart === "industry-page-revision" ||
      this.selectedChart === "industry-page-total-revision" ||
      this.selectedChart === "industry-page-average-revision"
    ) {
      return [this.radioValueEstimates];
    }
    return {
      from: this.periodList[0],
      to: this.periodList[this.periodList.length - 1],
    };
  }

  /**
   * Determines what should be the length to slice the ticker array according to chart radio value
   * @param {string} valCode - selected chart radio value
   * @returns {number} length to slice
   */
  getSliceLength(valCode: string): number {
    if (valCode === "top5") {
      return 5;
    }
    return 10;
  }

  /**
   * It stores the selected line item
   * It makes data call request and updates grid data
   * @param {obect} item - selected line item
   */
  updateLineItem(item) {
    this.lineItem = { ...item };
    this.suggestedLineItems = this.suggestedLineItems.map((el) => ({
      ...el,
      isSelected: el.id === item.id || el.id === item.uniquesliid,
    }));
    this.createAndFetchCompTableData();
    this.snackbarInfo.message = `${item.label} Line Item selected.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);

    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_UPDATE_LINEITEM",
      {
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        lineItem: getFormattedLineItemForTracking([item]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
  }

  /**
   * Executes on the selection of lineitem
   * It checks if lineitem exists or not and shows toast message according to it.
   * It formats the line item, and removes unnecessary items
   * It updates the line item
   * @param {object} item - selected lineitem
   */
  handleLineItemSelection(item) {
    if (item) {
      let formatLineItem = { ...item, parent: undefined }; // remove the parent property from selected lineitem
      if (this.lineItem && formatLineItem.value === this.lineItem.uniquesliid) {
        this.snackbarInfo.message = "This Line Item is already present.";
        this.snackbarInfo.type = "info";
        this.showSnackBarToastMessage(this.snackbarInfo);
      } else {
        this.isUserSettingUpdateInProgress = true;
        this.isLineUpdateInProgress = true;
        const userSettings = this.createUserTabSettings(
          formatLineItem,
          this.periodUserSetting,
          this.viewBy,
          this.revision,
        );
        const tempTickerId =
          this.tickers && this.tickers.length ? this.tickers[0].ticker : "";
        const apiCalls = [
          this.dataService.saveUserIndustryTabSettings(
            this.pageShortName,
            userSettings,
          ),
          this.dataService.getFormattedLineName(
            formatLineItem.value,
            this.industryId,
            this.currency,
            tempTickerId,
          ),
        ];

        forkJoin(apiCalls).subscribe((res) => {
          if (
            res[0].status === "success" &&
            res[1].status === "success" &&
            res[1].data
          ) {
            const lineName =
              res[1].data[formatLineItem.value] ||
              formatLineItem.name ||
              formatLineItem.label ||
              "";
            formatLineItem = {
              ...formatLineItem,
              name: lineName,
              label: lineName,
            };
            this.updateLineItem(formatLineItem);
          }
          this.isLineUpdateInProgress = false;
          this.isUserSettingUpdateInProgress = false;
        });
      }
    }
  }

  /**
   * Returns the formatted date in `MM-DD-YYYY` format
   * @param {Date} date - date to format
   * @returns {string} - date in given format
   */
  getFormattedDate(date: Date) {
    //format: mm-dd-yyyy
    return dayjs(date).format("MM-DD-YYYY");
  }

  /**
   * Returns the array of viewBy
   */
  getDataViewArray() {
    const result = [];
    if (this.compsTableData.filter.showValue) {
      result.push("values");
    }
    if (this.compsTableData.filter.showYoy) {
      result.push("yoy");
    }
    if (this.compsTableData.filter.showRevision) {
      result.push("revision");
    }
    return result.length ? result : undefined;
  }

  /**
   * Executes on click of Edit Table.
   * It creates an url with selected filters and redirects to comp page
   */
  handleEditTableClick() {
    const tickers = this.getTickerIdArray();
    if (!tickers || !this.lineItem) {
      return undefined;
    }
    const tickersUrl = `&tickers=${tickers.join("&tickers=")}`;
    const period = `&period=${this.periodList.join("&period=")}`;
    const periodType = `&period_type=${
      getPeriodTypeDataId(this.periodData) === "relative"
        ? "rel"
        : getPeriodTypeDataId(this.periodData)
    }`;
    const isAnnualSelected = `&is_annual_selected=${true}`;
    const periodUrl = `${period}${periodType}${isAnnualSelected}`;
    const uniqueSliIds = this.lineItem.uniquesliid;
    const tabName = this.industry;
    const currency = this.compsTableData.filter.currency || "USD";
    const dataView = this.getDataViewArray();
    const revision = this.compsTableData.filter.revision;
    let urlToCompPage = `/comptables/current?hideVsPeers=true&uniquesliids=${uniqueSliIds}${tickersUrl}&tab_name=${tabName}${periodUrl}&tab_type=va_comp&comp_type=TimeSeries&currency=${currency}`;
    if (dataView && dataView.length) {
      urlToCompPage += `&view_by=${dataView.join("&view_by=")}`;
    }
    if (revision) {
      const oneYearBack = new Date(
        new Date().setFullYear(new Date().getFullYear() - 1),
      );
      const twoYearBack = new Date(
        new Date().setFullYear(new Date().getFullYear() - 2),
      );
      const oneYearBackFormattedDate = `custom|${this.getFormattedDate(
        oneYearBack,
      )}`;
      const twoYearBackFormattedDate = `custom|${this.getFormattedDate(
        twoYearBack,
      )}`;
      const revisionMap = {
        "1y": oneYearBackFormattedDate,
        "2y": twoYearBackFormattedDate,
      };
      urlToCompPage += `&revision=${revisionMap[revision]}`;
    }

    const encodeUrl = encodeURI(urlToCompPage);
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_EDIT_COMP_TABLE",
      {
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        edit_comp_url: encodeUrl,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
    window.open(encodeUrl, "_blank");
    return undefined;
  }

  /**
   * Executes on selection of currency
   * It stores currency
   * @param {object} item - selected currency
   */
  handleCurrencyChange(item) {
    if (!item) {
      return;
    }
    this.isUserSettingUpdateInProgress = true;
    const userIndustrySettings = createUserIndustrySettings(
      item,
      this.industryId,
      this.subGroup,
      this.showBlankRows,
      this.isIndexToHundreadSelected,
    );
    const tempTickerId =
      this.tickers && this.tickers.length ? this.tickers[0].ticker : "";

    this.userIndustrySettingsSubscriber = this.dataService
      .saveUserIndustrySettings(userIndustrySettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.currency = item;
          const apiCalls = [
            this.compsDataService.getCurrencyMessage(item),
            this.dataService.getFormattedLineName(
              this.lineItem.uniquesliid,
              this.industryId,
              this.currency,
              tempTickerId,
            ),
          ];
          this.currencyMessageSubscriber = forkJoin(apiCalls).subscribe(
            (res) => {
              const currencyMessageApiHasData = res[0].status === "success";
              const updateLineNameApiHasData = res[1].status === "success";
              if (updateLineNameApiHasData) {
                const lineName =
                  res[1].data[this.lineItem.uniquesliid] ||
                  this.lineItem.name ||
                  this.lineItem.label ||
                  "";
                const formatLineItem = {
                  ...this.lineItem,
                  name: lineName,
                  label: lineName,
                };
                this.lineItem = { ...formatLineItem };
              }
              if (currencyMessageApiHasData) {
                this.magnitudeMessage = res[0]["magnitude_message"];
              }

              if (currencyMessageApiHasData || updateLineNameApiHasData) {
                this.createAndFetchCompTableData();
              }
            },
          );
          this.appService.logUserAction(
            {},
            "",
            "",
            "INDUSTRY_KPI_UPDATE_CURRENCY",
            {
              currency: item,
              tab_name: this.pageShortName,
              industry_id: this.industryId,
              lineItem: getFormattedLineItemForTracking([this.lineItem]),
            },
            "",
            INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
          );
        } else {
          this.snackbarInfo.message = "Could not update currency";
          this.snackbarInfo.type = "failure";
          this.showSnackBarToastMessage(this.snackbarInfo);
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  /**
   * Executes on period selection
   * It updates the selected period data to tab state
   *@param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodSelection(periodData) {
    const { updatedPeriodData, periodUserSettingData } = periodData;
    this.periodData = updatedPeriodData;
    this.periodUserSetting = periodUserSettingData;
    this.periodList = getSelectedPeriods(updatedPeriodData, true, false);
    const periodTypeId = periodUserSettingData.type;
    const selectedBasisId =
      this.periodData &&
      this.periodData.period_basis &&
      this.periodData.period_basis[periodTypeId]
        ? getSelectedBasisOptionId(
            this.periodData.period_basis[periodTypeId].from_basis,
          )
        : undefined;
    const isYearlyBasisId = isBasisFullYear(selectedBasisId);
    this.periodLabel =
      periodTypeId === "rel"
        ? this.periodList.map((item) =>
            convertRelativePeriodIdToLabel(item, isYearlyBasisId),
          )
        : this.periodList;
    this.setActiveAndEstimatedPeriod();
    this.createAndFetchCompTableData();
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_UPDATE_PERIOD",
      {
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        period: periodUserSettingData,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
  }

  /**
   * Executes on click of Period filter popup's Apply button.
   * It posts the selected period setting to user setting api
   * It updates periodData and periodSettings
   * @param {{updatedPeriodData: ValuationPeriodState, periodUserSettingData: PeriodUserSettingObj}} periodData: selected values from period filter popup
   */
  handlePeriodApply(periodData: {
    updatedPeriodData: PeriodState;
    periodUserSettingData: PeriodUserSettingObj;
  }) {
    this.isUserSettingUpdateInProgress = true;
    const userSettings = this.createUserTabSettings(
      this.lineItem,
      periodData.periodUserSettingData,
      this.viewBy,
      this.revision,
    );
    this.userTabSettingsSubscriber = this.dataService
      .saveUserIndustryTabSettings(this.pageShortName, userSettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.handlePeriodSelection(periodData);
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  /**
   * Executes on growth/revision change
   * It Updates `viewBy` and `revision`.
   * @param {{viewBy: Array, revision: string}} item - selected growth revision
   */
  updateGrowthRevision(item) {
    if (item) {
      this.isUserSettingUpdateInProgress = true;
      const userSettings = this.createUserTabSettings(
        this.lineItem,
        this.periodUserSetting,
        item.viewBy,
        item.revision,
      );
      this.userTabSettingsSubscriber = this.dataService
        .saveUserIndustryTabSettings(this.pageShortName, userSettings)
        .subscribe((response: { status: string; data: IndustryMeta }) => {
          if (response.status === "success") {
            this.viewBy = item.viewBy;
            this.revision = item.revision;
            this.dataview = {
              view_by: [...this.viewBy],
              revision: this.revision,
            };
            this.createAndFetchCompTableData();
            this.appService.logUserAction(
              {},
              "",
              "",
              "INDUSTRY_KPI_UPDATE_DATA_VIEW",
              {
                tab_name: this.pageShortName,
                industry_id: this.industryId,
                view_by: item.viewBy,
                revision: item.revision,
                lineItem: getFormattedLineItemForTracking([this.lineItem]),
              },
              "",
              INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
            );
          }
          this.isUserSettingUpdateInProgress = false;
        });
    }
  }

  /**
   * Executes on remove blanks switch change
   * It stores the value to user settings
   * @param {boolean} value - selected value of remove blank
   */
  handleShowBlanksSwitchChange(value) {
    this.isUserSettingUpdateInProgress = true;
    const userIndustrySettings = createUserIndustrySettings(
      this.currency,
      this.industryId,
      this.subGroup,
      value,
      this.isIndexToHundreadSelected,
    );
    this.userIndustrySettingsSubscriber = this.dataService
      .saveUserIndustrySettings(userIndustrySettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.updateDataOnShowBlankSwitchChange(value);
          this.showBlankRows = value;
          this.checkIfShowMoreLessExist();
          this.appService.logUserAction(
            {},
            "",
            "",
            "INDUSTRY_KPI_UPDATE_PERIOD",
            {
              tab_name: this.pageShortName,
              industry_id: this.industryId,
              remove_blanks: value,
              lineItem: getFormattedLineItemForTracking([this.lineItem]),
            },
            "",
            INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
          );
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  /**
   * Executes on click of Download Chart.
   * It uses chartInstance from HighChart and performs the action depending on download type
   * @param {number} downloadType - type of download
   */
  downloadValue(downloadType) {
    this.downloadOptVisible = false;
    let downloadTypeName = "";
    switch (downloadType) {
      case 0:
        downloadTypeName = "Download_PNG";
        break;
      case 1:
        downloadTypeName = "Download_JPEG";
        break;
      case 2:
        downloadTypeName = "Download_PDF";
        break;
      case 3:
        downloadTypeName = "Download_SVG";
        break;
      case 4:
        downloadTypeName = "Print_Chart";
        break;
      default:
        downloadTypeName = "Download_PNG";
    }
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_CHARTS_DOWNLOAD",
      {
        lines: [this.lineItem.uniquesliid],
        tickers: this.getTickerIdArray(),
        downloadInfo: downloadTypeName,
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
    this.chartInstance.options.title.text = this.industry;
    switch (downloadType) {
      case 0:
        this.chartInstance.exportChart(
          {
            type: "image/png",
            filename: this.industry,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 1:
        this.chartInstance.exportChart(
          {
            type: "image/jpeg",
            filename: this.industry,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 2:
        this.chartInstance.exportChart(
          {
            type: "application/pdf",
            filename: this.industry,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 3:
        this.chartInstance.exportChart(
          {
            type: "image/svg+xml",
            filename: this.industry,
            sourceWidth: 1920,
            sourceHeight: 1080,
          },
          this.chartInstance.options,
        );
        break;
      case 4:
        this.chartInstance.print();
        break;
      default:
        break;
    }
  }

  /**
   * Executes on click of Export chart option Download Chart.
   * Creates excel sheet by using chart filter and chart instance and saves it to users system
   */
  onExport(): void {
    let name = "";
    const chartTypeId =
      this.selectedChart === "industry-page-timeseries" ? "2" : "3";
    const xlsxRows = [
      [
        { type: "string", value: "Chart Name" },
        { type: "string", value: this.industry },
      ],
      [
        { type: "string", value: "Currency" },
        { type: "string", value: this.chartFilters.currency },
      ],
      [
        { type: "string", value: "Period" },
        { type: "string", value: this.chartFilters.periods },
      ],
      [
        { type: "string", value: "Rebase to 100" },
        {
          type: "string",
          value:
            this.chartFilters.scaleType !== "Index"
              ? this.chartFilters.scaleType
              : "Index to 100",
        },
      ],
      [
        { type: "string", value: "" },
        { type: "string", value: "" },
      ],
    ];
    if (this.chartFilters.scaleType !== "Index") {
      if (
        (Number(chartTypeId) !== 3 && this.chartFilters.dataView !== "yoy") ||
        Number(chartTypeId) === 3
      ) {
        xlsxRows.splice(4, 0, [
          { type: "string", value: "" },
          { type: "string", value: `All numbers in M unless stated otherwise` },
        ]);
      }
    }

    // rows = [],
    // headerRow = [];
    Number(chartTypeId) !== 3 &&
      xlsxRows.splice(3, 0, [
        { type: "string", value: "Values or YoY%" },
        { type: "string", value: this.chartFilters.dataView },
      ]);
    Number(chartTypeId) === 3 &&
      xlsxRows.splice(3, 0, [
        { type: "string", value: "Revision History" },
        {
          type: "string",
          value: this.chartFilters.revisionPeriod.startsWith("custom")
            ? this.chartFilters.revisionPEriod.split("|")[1]
            : this.chartFilters.revisionPeriod.replace("m", " months"),
        },
      ]);
    Number(chartTypeId) === 2 &&
      xlsxRows.splice(2, 1, [
        { type: "string", value: "Period" },
        {
          type: "string",
          value: `${this.chartFilters.periods["from"]} - ${this.chartFilters.periods["to"]}`,
        },
      ]);
    const tickers = this.getTickerIdArray();
    switch (Number(chartTypeId)) {
      case 1:
        {
          const headerRow = tickers.map((item) => {
            return { type: "string", value: item };
          });
          headerRow.unshift({ type: "string", value: "" });
          xlsxRows.push(headerRow);
          const rows = this.chartInstance.options.series.map((item, index) => {
            const magnitude = `${
              this.chartFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude &&
              this.chartFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude !== "" &&
              this.chartFilters.lineInfo[
                this.chartInstance.options.series[index]["custom"].parentLine
              ].magnitude !== "Abs" &&
              this.chartFilters.scaleType !== "Index" &&
              this.chartFilters.dataView !== "yoy"
                ? `(in ${
                    this.chartFilters.lineInfo[
                      this.chartInstance.options.series[index]["custom"]
                        .parentLine
                    ].magnitude
                  })`
                : ""
            }`;
            const row = [];
            row.push({ type: "string", value: `${item.name}${magnitude}` });
            item["data"].map((d) => {
              const type = typeof d.y === "number" ? "number" : "string";
              row.push({ type: type, value: d.y });
              return d;
            });
            return row;
          });
          rows.map((row) => {
            xlsxRows.push(row);
            return row;
          });
        }

        break;
      case 2:
        {
          let tsRow = [];
          const headRow = [{ type: "string", value: "Ticker" }];
          (this.chartInstance.xAxis[0].categories || []).map((x) =>
            headRow.push({ type: "string", value: x }),
          );
          this.chartInstance.options.series.map((item) => {
            if (item.name !== "") {
              tsRow = [];
              if (item["custom"].isLineItem) {
                const magnitude = `${
                  this.chartFilters.lineInfo[item["custom"].lineId].magnitude &&
                  this.chartFilters.lineInfo[item["custom"].lineId]
                    .magnitude !== "" &&
                  this.chartFilters.lineInfo[item["custom"].lineId]
                    .magnitude !== "Abs" &&
                  this.chartFilters.scaleType !== "Index" &&
                  this.chartFilters.dataView !== "yoy"
                    ? `(in ${
                        this.chartFilters.lineInfo[item["custom"].lineId]
                          .magnitude
                      })`
                    : ""
                }`;
                xlsxRows.push([]);
                xlsxRows.push([
                  { type: "string", value: `${item.name}${magnitude}` },
                ]);
                xlsxRows.push(headRow);
              } else {
                tsRow.push({ type: "string", value: item.name });
                item["data"].map((val) => {
                  tsRow.push({ type: "string", value: val.y });
                  return val.y;
                });
                xlsxRows.push(tsRow);
              }
            }
            return item;
          });
        }

        break;
      case 3:
        {
          let row = [];
          tickers.map((ticker, index) => {
            const rows = [];
            rows.push(
              { type: "string", value: ticker },
              { type: "string", value: "Period" },
            );
            xlsxRows.push([]);
            xlsxRows.push(rows);
            this.chartInstance.options.series.map((item) => {
              if (item.name !== "") {
                // row = [];
                if (item["custom"].isLineItem) {
                  row = [];
                  // rowData = [];
                  const magnitude = `${
                    this.chartFilters.lineInfo[item["custom"].lineId]
                      .magnitude &&
                    this.chartFilters.lineInfo[item["custom"].lineId]
                      .magnitude !== "" &&
                    this.chartFilters.lineInfo[item["custom"].lineId]
                      .magnitude !== "Abs" &&
                    this.chartFilters.scaleType !== "Index"
                      ? `(in ${
                          this.chartFilters.lineInfo[item["custom"].lineId]
                            .magnitude
                        })`
                      : ""
                  }`;
                  row.push({
                    type: "string",
                    value: `${item.name}${magnitude}`,
                  });
                } else {
                  if (item.name.split("-")[0] === tickers[index]) {
                    row.length ? row.splice(1) : null;
                    row.push({
                      type: "string",
                      value: item.name.split("-").slice(1).join("-"),
                    });
                    const dateRow = [
                      { type: "string", value: "" },
                      { type: "string", value: "" },
                    ];
                    item["data"].length &&
                      item["data"].map((d) => {
                        const xDate = Highcharts.dateFormat("%d-%b-%Y", d.x);
                        dateRow.push({ type: "string", value: xDate });
                        const type =
                          typeof d.y === "number" ? "number" : "string";
                        row.push({ type: type, value: d.y });
                        return d;
                      });
                    xlsxRows.push(dateRow);
                    xlsxRows.push([...row]);
                  }
                }
              }
              return item;
            });
            return ticker;
          });
        }

        break;
      default:
        console.error(
          `Chart with type id ${Number(chartTypeId)} is not supported`,
        );
    }

    name = `${this.industry} - ${
      INDUSTRY_PAGE_INFO[this.pageShortName].fullName
    }`;

    window.zipcelx({
      filename: name,
      sheet: {
        data: xlsxRows,
      },
    });
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_CHARTS_DOWNLOAD",
      {
        lines: [this.lineItem.uniquesliid],
        tickers: this.getTickerIdArray(),
        downloadInfo: "Export_Value",
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
    return;
  }

  onChartInstance(chartInstance: Highcharts.Chart) {
    if (chartInstance) {
      this.chartInstance = chartInstance;
    }
  }

  /**
   * Executes on selecting estimate
   */
  onEstimateChange() {
    this.yearTypeFilterVisible = false;
    if (this.lineItem === undefined || this.tickers.length === 0) {
      this.chartFilters = this.createChartFilter([], "", "");
      this.hasShowMoreButton = false;
      return;
    }
    this.chartInstance = null;
    this.chartFilters = this.createChartFilter(
      this.getTopTenTickers(
        this.lineItem.uniquesliid,
        this.selectedChart === "industry-chart-timeseries"
          ? this.activePeriod
          : this.radioValueEstimates,
        this.getViewByKey(),
      ),
      this.currencySymbol,
      this.getViewByKey(),
    );
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_UPDATE_CHART_ESTIMATE",
      {
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        estimate: this.radioValueEstimates,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
  }

  /**
   * Returns the tabId which can be used to pass it to export call
   * Since the current comp table doesn't has tabid, we generate it by making post call to saveNewComp
   * @returns {number} - tabId
   */
  getTabIdForExport() {
    const compName = this.getCompTableName();
    const tickerInfo = this.compsTableData.rows;
    const lineItemInfo = this.getLineItemInfo();
    const lineItemInfoArray = [];
    if (lineItemInfo) {
      lineItemInfoArray.push(lineItemInfo);
    }
    const tabType = CompTypes.timeseries;
    const periodSettings = this.periodUserSetting;
    const yearType = "Calendarized";
    const currency = this.currency;
    const viewBy = this.viewBy;
    const revision = this.revision;

    let dataView = {};
    if (viewBy) {
      dataView = { view_by: viewBy };
    }
    if (revision !== "") {
      dataView = { view_by: viewBy, revision: revision };
    }
    return this.compsDataService.saveNewComp(
      compName,
      tickerInfo,
      lineItemInfoArray,
      tabType,
      periodSettings,
      yearType,
      currency,
      dataView,
      false,
    );
  }

  /**
   * Executes on the click of export Values / Excel Add-In Formulas
   * According to export type it generated excel sheet
   * @param {number} exportType - type of export  0(Excel Add-In Formulas ) | 1(Values)
   */
  exportValue(exportType) {
    this.isCompExportPopoverVisible = false;
    const viewBy = this.viewBy;
    const currency = this.currency;
    const revision = this.revision;
    this.isCompTableExportInProgress = true;
    // for time series
    this.getTabIdForExport().subscribe((resp) => {
      if (resp["status"] === "success") {
        if (exportType === 0) {
          //#region  For export to addin
          //Allow values or yoy for excel version export
          if (
            viewBy.length === 1 &&
            (viewBy.includes("values") || viewBy.includes("yoy"))
          ) {
            let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${viewBy[0]}`;
            if (currency !== "Base") {
              params = `${params}&currency=${currency}`;
            }
            this.downloadTrends(params, resp["tab_id"], exportType);
          } else {
            //Allow values and yoy for excel version export
            if (
              viewBy.length === 2 &&
              viewBy.includes("values") &&
              viewBy.includes("yoy")
            ) {
              let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${viewBy[0]}&viewBy=${viewBy[1]}`;
              if (currency !== "Base") {
                params = `${params}&currency=${currency}`;
              }
              this.downloadTrends(params, resp["tab_id"], exportType);
            } else {
              this.snackbarInfo.message =
                "Excel export is not yet available. We will be adding this feature very soon.";
              this.snackbarInfo.type = "failure";
              this.showSnackBarToastMessage(this.snackbarInfo);
              this.isCompTableExportInProgress = false;
            }
          }
          //#endregion
        } else {
          //Export Value version
          if (viewBy.length < 2) {
            let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}`;
            //Export Revision for values
            if (viewBy.length && viewBy.includes("revision")) {
              params += `&viewBy=revision`;
              if (revision && revision !== "") {
                params += `&revision=${revision}`;
              }
            } else {
              //export value or yoy for values
              params += `&viewBy=${viewBy[0]}`;
            }
            if (currency !== "Base") {
              params = `${params}&currency=${currency}`;
            }
            this.downloadTrends(params, resp["tab_id"], exportType);
          } else {
            //Allow values and yoy for value version export
            if (
              viewBy.length === 2 &&
              viewBy.includes("values") &&
              viewBy.includes("yoy")
            ) {
              let params = `tabid=${resp["tab_id"]}&comps_type=${this.timeSeriesExportType}&export_type=${exportType}&viewBy=${viewBy[0]}&viewBy=${viewBy[1]}`;
              if (currency !== "Base") {
                params = `${params}&currency=${currency}`;
              }
              this.downloadTrends(params, resp["tab_id"], exportType);
            } else {
              this.snackbarInfo.message =
                "Excel export is not yet available. We will be adding this feature very soon.";
              this.snackbarInfo.type = "failure";
              this.showSnackBarToastMessage(this.snackbarInfo);
              this.isCompTableExportInProgress = false;
            }
          }
        }
      } else {
        console.error("Could not generate tab id");
        this.snackbarInfo.message = "Something went wrong";
        this.snackbarInfo.type = "failure";
        this.showSnackBarToastMessage(this.snackbarInfo);
        this.isCompTableExportInProgress = false;
      }
    });
  }

  /**
   * Generates excel sheet and downloads it
   * @param {string} params - formatted string with params required for exporting excel
   * @param {number} tabid - tabId of comp table
   * @param {number} exportType - type of export  0(Excel Add-In Formulas ) | 1(Values)
   */
  downloadTrends(params, tabid, exportType) {
    this.isCompTableExportInProgress = true;
    const applyYoyFormat = true;
    const pageName = this.pageShortName;
    params = `${params}&apply_yoy_format=${applyYoyFormat}&template_type=industry%20kpi&sector_name=${this.sector}&industry_name=${this.industry}&industry_id=${this.industryId}&page_name=${pageName}&tab_id=${tabid}`;
    this.dataService
      .downloadIndustryExport(
        params,
        this.subGroup,
        this.region,
        this.marketCap,
        this.countries,
      )
      .subscribe(
        (res) => {
          if (res["status"] === "success") {
            const fileName = res["filename"];
            const trackerId = res["trackerid"];
            const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
            const startIFrameTime = new Date().getTime();
            const iFrameToLoad = this._document.createElement("iframe");
            const body = this._document.getElementsByTagName("body")[0];
            iFrameToLoad.id = `${fileName}`;
            iFrameToLoad.name = `${fileName}`;
            iFrameToLoad.src = downloadUrl;
            iFrameToLoad.setAttribute(
              "style",
              "visibility:hidden;display:none",
            );
            body.appendChild(iFrameToLoad);

            const checkInterval = setInterval(() => {
              const iFrameToGet = this._document.getElementById(
                `${fileName}`,
              ) as HTMLIFrameElement;
              const iFrame =
                iFrameToGet.contentDocument ||
                iFrameToGet.contentWindow.document;
              /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
              if (
                iFrame.readyState === "complete" ||
                iFrame.readyState === "interactive" ||
                new Date().getTime() - startIFrameTime > 30000
              ) {
                //Commenting for now
                // this._document
                //   .getElementById(`research_download_${dataToPass.id}`)
                //   .remove();
                clearInterval(checkInterval);
                return;
              }
            }, 2000);
            this.isCompTableExportInProgress = false;
            // iframe.onload = () => {
            //   setTimeout(function() {
            //     document.getElementById(`research_download_${dataToPass.id}`).remove();
            //   }, 100);
            //   this.loading = false;
            // };
            this.appService.logUserAction(
              {},
              "",
              "",
              "INDUSTRY_KPI_COMPS_EXCEL_EXPORT",
              {
                tab_name: this.pageShortName,
                industry_id: this.industryId,
                export_type: exportType,
                tracker_id: trackerId,
                file_name: fileName,
                lineItem: getFormattedLineItemForTracking([this.lineItem]),
              },
              "",
              INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
            );
          } else {
            this.isCompTableExportInProgress = false;
            this.snackbarInfo.message =
              "Industry export couldn't be downloaded.";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
        },
        (err) => {
          this.isCompTableExportInProgress = false;
          console.error(err);
        },
      );
  }

  /**
   * Returns the line item name
   * @returns {string} - Lineitem name
   */
  getCompTableName() {
    return this.lineItem ? this.lineItem.name : "";
  }

  /**
   * Returns the formatted line item
   * @returns {object} - Lineitem
   */
  getLineItemInfo() {
    if (!this.lineItem) {
      return undefined;
    }
    return {
      fuzzysli: 0,
      name: this.lineItem.name,
      period: this.periodList,
      sli_comps_id: this.lineItem.uniquesliid,
      sli_id: this.lineItem.uniquesliid,
      source: "VA Actuals/Consensus",
    };
  }

  /**
   * Executes on selecting chart radio and updates chart filters
   */
  onChangeChartView() {
    if (this.lineItem === undefined || this.tickers.length === 0) {
      this.chartFilters = this.createChartFilter([], "", "");
      this.hasShowMoreButton = false;
    } else {
      this.chartInstance = null;

      this.chartFilters = this.createChartFilter(
        this.getTopTenTickers(
          this.lineItem.uniquesliid,
          this.selectedChart === "industry-chart-timeseries"
            ? this.activePeriod
            : this.radioValueEstimates,
          this.getViewByKey(),
        ),
        this.currencySymbol,
        this.getViewByKey(),
      );
      this.appService.logUserAction(
        {},
        "",
        "",
        "INDUSTRY_KPI_UPDATE_CHART_FILTER",
        {
          tab_name: this.pageShortName,
          industry_id: this.industryId,
          chart_filter: this.radioValue,
          lineItem: getFormattedLineItemForTracking([this.lineItem]),
        },
        "",
        INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
      );
    }
  }

  yearTypePopoverChange() {
    this.yearTypePopoverOpen = !this.yearTypePopoverOpen;
    if (this.yearTypePopoverOpen) {
      this.yearTypeApplied = false;
    }
    if (!this.yearTypePopoverOpen && !this.yearTypeApplied) {
      // this.onResetYearType();
    }
  }

  /**
   * Determines the viewBy value for chart.
   * When viewByArr contains `values` and `yoy`, it should return `value` as it has more preference. In rest of the cases it should return what it contains.
   * @param {array} viewByArr - array of viewBy values
   * @returns {string} - viewBy value
   */
  getViewByValueForChart(viewByArr = []) {
    let viewBy = "value";
    if (viewByArr.includes("revision")) {
      viewBy = "revision";
    } else if (viewByArr.includes("yoy") && viewByArr.length === 1) {
      viewBy = "yoy";
    }
    return viewBy;
  }

  /**
   * Executes on click of Edit Chart.
   * It creates an url with selected filters and redirects to chart page
   */
  handleEditChartClick() {
    if (
      !this.chartFilters ||
      !this.chartFilters.tickers ||
      !this.chartFilters.lineInfo
    ) {
      return;
    }

    const tickers = this.chartFilters.tickers || [];
    const tickersUrl = `&ticker=${tickers.join("&ticker=")}`;
    const revision = this.chartFilters.revisionPeriod;
    const chartTypeId = Number(
      this.selectedChart === "industry-page-timeseries" ? "2" : "3",
    );

    const period =
      Number(chartTypeId) === 3 && revision
        ? `&periods=${this.radioValueEstimates}`
        : `&periods=${this.periodList.join("&periods=")}`;
    const periodType = `&period_type=${
      getPeriodTypeDataId(this.periodData) === "relative" ? "rel" : "abs"
    }`;
    const isAnnualSelected = `&is_annual_selected=${true}`;
    const periodUrl = `${period}${periodType}${isAnnualSelected}`;
    const uniqueSliIds = this.lineItem.uniquesliid;
    const tabName = this.industry;
    const currency = this.chartFilters.currency || "USD";
    const viewBy = this.getViewByValueForChart(this.viewBy);
    const scaleType = this.isIndexToHundreadSelected ? "Index" : "Absolute";

    let urlToCompPage = `/charts/current?hideVsPeers=true&lineId=${uniqueSliIds}${tickersUrl}&chartTypeId=${chartTypeId}&chart_name=${tabName}${periodUrl}&currency=${currency}&scale_type=${scaleType}`;
    if (Number(chartTypeId) === 3 && revision) {
      urlToCompPage += `&revision=${revision}`;
    } else if (viewBy) {
      urlToCompPage += `&view_by=${viewBy}`;
    }
    const encodeUrl = encodeURI(urlToCompPage);
    this.appService.logUserAction(
      {},
      "",
      "",
      "INDUSTRY_KPI_EDIT_CHART",
      {
        tab_name: this.pageShortName,
        industry_id: this.industryId,
        edit_chart_url: encodeUrl,
        lineItem: getFormattedLineItemForTracking([this.lineItem]),
      },
      "",
      INDUSTRY_PAGE_INFO.kpis.pageNameForTracking,
    );
    window.open(encodeUrl, "_blank");
  }

  /**
   * Handler for mega menu visibility change event
   */
  onMegaMenuVisibilityChange(isVisible: boolean) {
    this.isMegaMenuVisible = isVisible;
  }

  /**
   * @returns {number} returns initial height of comp table(40% of viewport)
   */
  getShowMLTableInitialHeight() {
    const windowHeight = window.innerHeight;
    const calculatedHeight = (windowHeight * 37) / 100; // initial height should be 37% of screen height
    return Math.floor(calculatedHeight);
  }

  /**
   * @returns {number} returns height of comp table in active state (Comp table should extend till the end of the viewport)
   */
  getShowMLTableActiveStateHeight() {
    const extraSpace = 240 + 30 + 24 + 34; // space above the table + table title height + show more button height + footer + fiscal tooltip
    const windowHeight = window.innerHeight;
    return Math.floor(windowHeight - extraSpace);
  }

  /**
   * Executes on Change now button click of no ticker popup
   * It hides the no ticker popup and shows region filter popup
   */
  onNoTickerPopupChangeClick() {
    this.isNoTickerPopupVisible = false;
    if (this.store) {
      this.store.dispatch(
        new SetIndustryMengMenuVisibility({
          isIndustryMegaMenuVisible: true,
        }),
      );
    }
  }

  /**
   * It creates user tab settings object
   * @param {array} lineItem - array of lineitem id
   * @param {object} period - period settings
   * @param {array} viewByArr - array of viewBy values
   * @param {string} revision - revision value
   * @return {object} user tab setting object which is used to save the selected filters
   */
  createUserTabSettings(
    lineItem,
    period?: PeriodUserSettingObj,
    viewBy?: Array<string>,
    revision?: string,
  ) {
    const formattedLineItem = lineItem
      ? [
          {
            uniquesliid: lineItem.uniquesliid || lineItem.sli_id,
          },
        ]
      : undefined;
    return {
      lineitem: formattedLineItem,
      period,
      view_by: viewBy,
      revision,
      industry_id: this.industryId,
      subindustry_id: [this.subGroup],
    };
  }

  handleIndexCheckobChange(item) {
    this.isUserSettingUpdateInProgress = true;
    const userIndustrySettings = createUserIndustrySettings(
      this.currency,
      this.industryId,
      this.subGroup,
      this.showBlankRows,
      item,
    );
    this.userIndustrySettingsSubscriber = this.dataService
      .saveUserIndustrySettings(userIndustrySettings)
      .subscribe((response: { status: string; data: IndustryMeta }) => {
        if (response.status === "success") {
          this.chartFilters = this.createChartFilter(
            this.getTopTenTickers(
              this.lineItem.uniquesliid,
              this.selectedChart === "industry-chart-timeseries"
                ? this.activePeriod
                : this.radioValueEstimates,
              this.getViewByKey(),
            ),
            this.currencySymbol,
            this.getViewByKey(),
          );
        }
        this.isUserSettingUpdateInProgress = false;
      });
  }

  getPeriodsWithAvailableData(tickerIds) {
    this.appService
      .getPeriodsWithData(tickerIds)
      .subscribe((response: { status; dataAvailable }) => {
        if (response.status === "success") {
          this.periodsWithAvailableData = response.dataAvailable;
        }
      });
  }
}
